import React from 'react'
import { RenderCommonUpload } from '../renderCommonUpload'

export const CollageBlockEight = ({IsSavedInputs,blockImages,setBlockImages,preview=false}) => {
  return (
    <div className={`w-full p-4 bg-gray-200 rounded-lg flex flex-col gap-4 `}>
        <div className="w-full flex justify-evenly gap-4">
          <div className="w-[70%] border-2 border-blue-500 md:h-[100px] lg:h-[156px]">
              <RenderCommonUpload buttonIndex={0} IsSavedInputs={IsSavedInputs} blockImages={blockImages} 
              setBlockImages={setBlockImages} preview={preview} dimension={"15.1:5.7"}/>
          </div>
          <div className="w-[30%] border-2 border-blue-500 md:h-[100px] lg:h-[156px]">
              <RenderCommonUpload buttonIndex={1} IsSavedInputs={IsSavedInputs} blockImages={blockImages} 
              setBlockImages={setBlockImages} preview={preview} dimension={"6.8:5.7"}/>
          </div>
        </div>
        
    </div>
  )
}
